module.exports = __webpack_public_path__ + "static/media/sourcing_cv_i.3924c90f.jpg";